import { useTooltip } from '@/utils/useTooltip'

// v-text-tooltip 디렉티브와 GlobalTooltip 컴포넌트가 함께 쓰는 툴팁 상태(앱 전체에 하나).
export const globalTooltip = useTooltip({ width: 120, height: 40 })
